"use strict";
/**
 * This file provides common helpful utility types.
 */
Object.defineProperty(exports, "__esModule", { value: true });
